<div class="header">
  <div class="title">Add Sheet</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addProjectSheetForm">
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Name</mat-label>
      <input matInput [formControlName]="'name'" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Select Template</mat-label>
      <mat-select [formControlName]="'sheet_template_id'">
        <mat-option *ngFor="let sheetTemplate of sheetTemplates" [value]="sheetTemplate.id">
          {{ sheetTemplate.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="addProjectSheetForm.pristine || addProjectSheetForm.invalid"
        (click)="saveAndClose()"
      >
        <span *ngIf="!addProjectSheetForm.disabled"> Add </span>
        <mat-progress-spinner
          *ngIf="addProjectSheetForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
